import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import ServiceConfigurator from "@/pages/ServiceConfigurator";
import Schedule from "@/pages/Schedule";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Confirmation from "@/pages/Confirmation";
import Track from "@/pages/Track";
import Admin from "@/pages/Admin";
import AdminPricing from "@/pages/AdminPricing";
import Warranty from "@/pages/Warranty";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import RequireAdmin from "@/components/RequireAdmin";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import PolicyPage from "@/pages/PolicyPage";
import AdminBookingDetail from "@/pages/AdminBookingDetail";
import AdminSettings from "@/pages/AdminSettings";
import Authorize from "@/pages/Authorize";
import ClaimCheckPrint from "@/pages/ClaimCheckPrint";
import InvoicePrint from "@/pages/InvoicePrint";
import MfaSetup from "@/pages/MfaSetup";
import MfaVerify from "@/pages/MfaVerify";
import axios from "axios";
axios.defaults.withCredentials = true;

function AppShell() {
  const location = useLocation();
  // Detect Emergent Auth callback in URL fragment (must be synchronous during render)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <main className="min-h-[calc(100vh-80px)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:deviceType" element={<ServiceConfigurator />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/checkout/:bookingId" element={<Checkout />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/confirmation/:bookingId" element={<Confirmation />} />
          <Route path="/track" element={<Track />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/mfa/verify" element={<MfaVerify />} />
          <Route path="/admin/mfa/setup" element={<RequireAdmin><MfaSetup /></RequireAdmin>} />
          <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          <Route path="/admin/pricing" element={<RequireAdmin><AdminPricing /></RequireAdmin>} />
          <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
          <Route path="/admin/bookings/:bookingId" element={<RequireAdmin><AdminBookingDetail /></RequireAdmin>} />
          <Route path="/admin/bookings/:bookingId/claim-check" element={<RequireAdmin><ClaimCheckPrint /></RequireAdmin>} />
          <Route path="/admin/bookings/:bookingId/invoice" element={<RequireAdmin><InvoicePrint /></RequireAdmin>} />
          <Route path="/authorize/:bookingId" element={<Authorize />} />
          <Route path="/policy/:slug" element={<PolicyPage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
